<template>
  <div>
    <div class="row-tb-head" style="display: flex; margin-top: 10px">
      <div style="margin-right: 10px">原料清单</div>
      <div>
        <el-button type="primary" @click="onPrint">打印</el-button>
      </div>
      <template
        ><span style="margin-left: 18px">订货类型</span>
        <span style="margin: 0 10px">
          <el-select v-model="OrderType" v-if="Status === 0" @change="changeOrderType" :disabled="!selList.length">
            <el-option
              v-for="item in [
                { label: '按单订货', value: 1 },
                { label: '按库存订货', value: 2 }
              ]"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select> </span
      ></template>
    </div>
    <el-table
      ref="list3"
      :data="MaterialsBom"
      class="table_bottom table-line tb-c-head"
      border
      max-height="353"
      :row-class-name="tableRowClassName"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column prop="ProductName" label="子件名称" min-width="220" fixed="left"></el-table-column>
      <el-table-column prop="ProductNo" label="子件编码" min-width="120"></el-table-column>
      <el-table-column
        key="column1"
        prop="OrderType"
        label="订货类型"
        min-width="120"
        :filters="[
          { text: '按单订货', value: 1 },
          { text: '按库存订货', value: 2 }
        ]"
        :filter-method="filterOrderType"
      >
        <template slot-scope="{ row }">
          <el-select v-model="row.OrderType" v-if="Status === 0">
            <el-option
              v-for="item in [
                { label: '按单订货', value: 1 },
                { label: '按库存订货', value: 2 }
              ]"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
          <span v-else>{{ row.OrderType == 1 ? '按单订货' : row.OrderType == 2 ? '按库存订货' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="160"></el-table-column>
      <el-table-column prop="BatchNumber" label="批号" min-width="160"></el-table-column>
      <el-table-column prop="BarCode" label="存货条码" min-width="120"></el-table-column>
      <el-table-column prop="UnitName" label="单位" min-width="80"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100"></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100"></el-table-column>
      <el-table-column prop="Quantity" label="需求数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Imgs" label="图片" min-width="50">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ProduceTypeName" label="存货类型" min-width="100"> </el-table-column>
      <el-table-column prop="TradeUnitFullName" label="供应商" min-width="120"> </el-table-column>
      <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" type="text" @change="editT(row)" v-if="Status === 0"></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import accountSelect from '../select'
import imgDialog from './imgDialog'

export default {
  components: {
    accountSelect,
    imgDialog
  },
  data() {
    return {
      pdApi: require('@/api/ba/product').default,
      MaterialsBom: [],
      OrderType: null, //订货类型
      selList: []
    }
  },
  props: {
    Status: {
      type: Number,
      default: 1
    },
    scQuantity: {
      type: Number,
      default: ''
    },
    MaterialsData: {
      type: Array,
      default: () => []
    },
    editType: {
      type: Number,
      default: 0
    },
    OrderProductNo: {
      type: String,
      default: ''
    }
  },
  watch: {
    scQuantity(val) {
      console.log('*************com val**************', val)
      this.MaterialsBom.forEach(item => {
        if (item.qua) {
          if (this.editType === 1 && item.T !== 0) {
            item.T = 1
          }
          item.qua = Math.ceil(item.Quantity * val)
        }
      })
    },
    MaterialsData(val) {
      this.MaterialsBom = JSON.parse(JSON.stringify(val))
      this.MaterialsBom.forEach(item => {
        item.Rate = 0
      })
    }
  },
  created() {},
  methods: {
    /** 批量操作 */
    handleSelectionChange(val) {
      this.selList = val
    },
    changeOrderType() {
      this.MaterialsBom = this.MaterialsBom.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 =>  obj2.ProductId === obj1.ProductId)
        if (duplicateObj) {
          obj1.OrderType = this.OrderType
        }
        return obj1
      })
      this.OrderType = ''
    },
    filterOrderType(value, row) {
      return row.OrderType === value
    },
    onPrint() {
      let newpage = this.$router.resolve({
        path: '/clothOuterPrint',
        query: {
          MaterialsBom: JSON.stringify(this.MaterialsBom),
          OrderProductNo: this.OrderProductNo
        }
      })
      window.open(newpage.href, '_blank')
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },

    editT(row) {
      // if(this.editType === 1 && row.T !== 0){
      //   row.T = 1;
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-end;
  margin: 6px 0;
}
.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.mr8 {
  margin-right: 8px;
}
</style>
